module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/urgent-mail-5638cabcb902f238994ce9811383f06b.svg";